var _rect, _path, _line, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 36,
    viewBox: "0 0 100 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 35,
    rx: 17.5,
    fill: "#817A96",
    fillOpacity: 0.08,
    stroke: "url(#paint0_linear_702_1795)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.078 23V13.2H18.156V22.034H23.994V23H17.078ZM25.3312 23V15.986H26.3672V23H25.3312ZM25.8492 14.642C25.6626 14.642 25.4992 14.572 25.3592 14.432C25.2192 14.292 25.1492 14.1287 25.1492 13.942C25.1492 13.746 25.2192 13.5827 25.3592 13.452C25.4992 13.312 25.6626 13.242 25.8492 13.242C26.0452 13.242 26.2086 13.312 26.3392 13.452C26.4792 13.5827 26.5492 13.746 26.5492 13.942C26.5492 14.1287 26.4792 14.292 26.3392 14.432C26.2086 14.572 26.0452 14.642 25.8492 14.642ZM28.134 23V15.986H29.17V16.812C29.7206 16.168 30.458 15.846 31.382 15.846C31.914 15.846 32.3806 15.9627 32.782 16.196C33.1926 16.42 33.51 16.7373 33.734 17.148C33.9673 17.5493 34.084 18.0207 34.084 18.562V23H33.062V18.772C33.062 18.1467 32.8846 17.6567 32.53 17.302C32.1846 16.938 31.7086 16.756 31.102 16.756C30.682 16.756 30.3086 16.8493 29.982 17.036C29.6553 17.2227 29.3846 17.4887 29.17 17.834V23H28.134ZM35.8175 23V13.2L36.8535 12.962V19.15L40.5215 15.986H41.7815L37.9315 19.318L41.9635 23H40.5495L36.8535 19.64V23H35.8175ZM44.8388 23.14C44.2601 23.14 43.7141 23.0467 43.2008 22.86C42.6968 22.664 42.2581 22.3933 41.8848 22.048L42.5148 21.376C42.8415 21.6747 43.2008 21.908 43.5928 22.076C43.9848 22.2347 44.3861 22.314 44.7968 22.314C45.3568 22.314 45.8141 22.1973 46.1688 21.964C46.5235 21.7307 46.7008 21.4273 46.7008 21.054C46.7008 20.746 46.5935 20.508 46.3788 20.34C46.1735 20.1627 45.8468 20.0413 45.3988 19.976L44.1808 19.808C43.4808 19.7053 42.9581 19.4953 42.6128 19.178C42.2768 18.8607 42.1088 18.4313 42.1088 17.89C42.1088 17.498 42.2208 17.148 42.4448 16.84C42.6688 16.532 42.9768 16.2893 43.3688 16.112C43.7701 15.9347 44.2275 15.846 44.7408 15.846C45.2541 15.846 45.7348 15.9207 46.1828 16.07C46.6308 16.2193 47.0695 16.4527 47.4988 16.77L46.9528 17.47C46.5608 17.1993 46.1781 17.0033 45.8048 16.882C45.4408 16.7513 45.0675 16.686 44.6848 16.686C44.1995 16.686 43.8075 16.7933 43.5088 17.008C43.2101 17.2227 43.0608 17.5027 43.0608 17.848C43.0608 18.1653 43.1635 18.408 43.3688 18.576C43.5741 18.7347 43.9055 18.8467 44.3628 18.912L45.5808 19.08C46.2808 19.1733 46.8035 19.3787 47.1488 19.696C47.5035 20.0133 47.6808 20.4473 47.6808 20.998C47.6808 21.3993 47.5548 21.7633 47.3028 22.09C47.0508 22.4167 46.7101 22.6733 46.2808 22.86C45.8608 23.0467 45.3801 23.14 44.8388 23.14Z",
    fill: "#E6DAFE"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.6,
    x1: 63.4814,
    y1: 30,
    x2: 63.4814,
    y2: 6,
    stroke: "url(#paint1_linear_702_1795)",
    strokeWidth: 1.03721
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3334 23.6667V20C86.3334 19.6334 86.0334 19.3334 85.6667 19.3334C85.3001 19.3334 85.0001 19.6334 85.0001 20V23H75.0001V13H78.0001C78.3667 13 78.6667 12.7 78.6667 12.3334C78.6667 11.9667 78.3667 11.6667 78.0001 11.6667H74.3334C73.9667 11.6667 73.6667 11.9667 73.6667 12.3334V23.6667C73.6667 24.0334 73.9667 24.3334 74.3334 24.3334H85.6667C86.0334 24.3334 86.3334 24.0334 86.3334 23.6667Z",
    fill: "url(#paint2_linear_702_1795)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3334 12.3334V12.2V12.1334C86.3334 12.1 86.3334 12.1 86.3001 12.0667C86.3001 12.0334 86.2667 12.0334 86.2667 12C86.2667 11.9667 86.2334 11.9667 86.2334 11.9334C86.2001 11.9 86.1667 11.8667 86.1667 11.8334C86.1334 11.8 86.1001 11.7667 86.0667 11.7667C86.0667 11.7667 86.0334 11.7334 86.0001 11.7334C85.9667 11.7334 85.9667 11.7 85.9334 11.7C85.9001 11.7 85.9001 11.7 85.8667 11.6667C85.8334 11.6667 85.8334 11.6667 85.8001 11.6334H81.6667C81.3001 11.6334 81.0001 11.9334 81.0001 12.3C81.0001 12.6667 81.3001 12.9667 81.6667 12.9667H84.0667L77.8667 19.2C77.6001 19.4667 77.6001 19.8667 77.8667 20.1334C78.0001 20.2667 78.1667 20.3334 78.3334 20.3334C78.5001 20.3334 78.6667 20.2667 78.8001 20.1334L85.0001 13.9334V16.3334C85.0001 16.7 85.3001 17 85.6667 17C86.0334 17 86.3334 16.7 86.3334 16.3334V12.3334Z",
    fill: "url(#paint3_linear_702_1795)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_702_1795",
    x1: 0,
    y1: 18,
    x2: 100,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_702_1795",
    x1: 64.5,
    y1: 30,
    x2: 64.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513189,
    stopColor: "#817A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#110F23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_702_1795",
    x1: 73.6667,
    y1: 18,
    x2: 86.3334,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_702_1795",
    x1: 77.6667,
    y1: 15.9834,
    x2: 86.3334,
    y2: 15.9834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353148"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.4433e29c4dcab72a0549427d71dc1749.svg";
export { ForwardRef as ReactComponent };